import { EChartOption } from 'echarts';
/**
 * Instant char options
 */
export const ZERO_INJECTION_INSTANT_CHART_OPTIONS: EChartOption = {
  tooltip: {
    show: true,
    triggerOn: 'mousemove',
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      }
    }
  },
  toolbox: {
    show: true,
    left: 'center',
    itemSize: 20,
    top: '0%',
    feature: {
      dataZoom: {
        show: true,
        yAxisIndex: true,
        title: {zoom: 'Zoom', back: 'Anular.', refresh: 'Refrescar'}
      },
      restore: {show: true, title: 'Anular Todo'},
      saveAsImage: {title: 'Descargar'}
    }
  },
  dataZoom: [
    {type: 'inside', xAxisIndex: [0, 1]},
    {type: 'slider', xAxisIndex: [0, 1], left: 'center'}],
  legend: {
      show: false,
      selected: null
  },
  grid: [
      { left: '7%', top: '15%', width: '38%'},
      { left: '54%', top: '15%', width: '38%'}
  ],
  xAxis: [
      {gridIndex: 0, type: 'category', data: []},
      {gridIndex: 1, type: 'category', data: []}
  ],
  yAxis: [
      {gridIndex: 0},
      {gridIndex: 0},
      {gridIndex: 1},
  ],
  series: []
};

export const ZERO_INJECTION_ARMONIC_CHART_OPTIONS: EChartOption = {
  tooltip: {
    show: true,
    triggerOn: 'mousemove',
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      }
    }
  },
  toolbox: {
    show: true,
    left: 'center',
    itemSize: 20,
    top: '0%',
    feature: {
      dataZoom: {
        show: true,
        yAxisIndex: true,
        title: {zoom: 'Zoom', back: 'Anular.', refresh: 'Refrescar'}
      },
      restore: {show: true, title: 'Anular Todo'},
      saveAsImage: {title: 'Descargar'}
    }
  },
  dataZoom: [
    {type: 'inside', xAxisIndex: [0]},
    {type: 'slider', xAxisIndex: [0], left: 'center'}],
  legend: {
      show: false,
      selected: null
  },
  grid: {left: '8%', right: '5%', bottom: '25%'},
  xAxis: [
      {gridIndex: 0, type: 'category', data: []},
  ],
  yAxis: [
      {gridIndex: 0}
  ],
  series: []
};


/**
 * Initial options for chart
 */
export const INIT_OPTIONS = {
  renderer: 'svg',
  width: 'auto',
  height: 'auto'
};
